<h2 mat-dialog-title class="dialog-title">Filtrar {{ data.headerLabel }}</h2>

<mat-divider></mat-divider>

<mat-dialog-content class="dialog-content">
	<mat-form-field class="search-field">
		<mat-label>Pesquisar</mat-label>
		<input matInput type="text" [(ngModel)]="searchTerm" placeholder="Digite para filtrar..." />
		<button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Limpar" (click)="searchTerm = ''">
			<mat-icon>close</mat-icon>
		</button>
	</mat-form-field>

	<div class="filter-actions">
		<label class="checkbox-filter">
			<input type="checkbox" [checked]="isAllSelected()" (change)="toggleSelectAll()" />
			{{ isAllSelected() ? 'Desmarcar todos' : 'Marcar todos' }}
		</label>
	</div>

	<mat-divider></mat-divider>

	<div class="filter-options">
		<label *ngFor="let value of filteredValues()" class="checkbox-option">
			<input
				type="checkbox"
				[checked]="selectedValues.has(value)"
				(change)="onCheckboxChange($event, value)"
			/>
			{{ value || '(Vazio)' }}
		</label>
	</div>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions align="end" class="dialog-actions">
	<button mat-stroked-button (click)="close()">Cancelar</button>
	<button mat-raised-button class="btn-apply" (click)="apply()">Aplicar</button>
</mat-dialog-actions>
